import React from "react";
import { useSelector } from "react-redux";
import { useGetResources } from "../../hooks/useGetResources";
import styles from "../../styles/index.module.scss";
import Tabs from "@helsenorge/designsystem-react/components/Tabs";
import { OppgaveListe } from "./OppgaveListe";
import { TabType } from "../../enums/tabType";
import { useAppDispatch, type RootState } from "../../store/reducer";
import { setActiveTabType } from "../../store/slices/slice-oppgaveListe";
import { isAuthorized } from "@helsenorge/framework-utils/hn-authorize";
import { AnonymousPage } from "./AnonymousPage";

export const OppgaveOversikt: React.FC = () => {
  const resources = useGetResources();
  const dispatch = useAppDispatch();
  const activeTabType = useSelector(
    (state: RootState) => state.oppgaveListe.activeTabType,
  );

  const activeTabIndex = activeTabType === TabType.Aktuelle ? 0 : 1;

  const handleTabClick = (index: number) => {
    const newTabType = index === 0 ? TabType.Aktuelle : TabType.Tidligere;
    dispatch(setActiveTabType(newTabType));
  };

  return (
    <div className={styles.oppgave_page}>
      {!isAuthorized() && <AnonymousPage />}
      {isAuthorized() && (
        <Tabs activeTab={activeTabIndex}>
          <Tabs.Tab
            title={resources?.fane_aktuelle || ""}
            onTabClick={() => handleTabClick(0)}
          >
            <OppgaveListe />
          </Tabs.Tab>
          <Tabs.Tab
            title={resources?.fane_tidligere || ""}
            onTabClick={() => handleTabClick(1)}
          >
            <OppgaveListe />
          </Tabs.Tab>
        </Tabs>
      )}
    </div>
  );
};
